<!--
  error.vue

  2026-01-08: Redesigned with Boom branding, animations, and professional look
  2025-12-29: Replaced placeholder text with proper 404 error page
-->
<template>
  <div class="error-page">
    <!-- Animated background elements -->
    <div class="bg-elements">
      <div class="circle circle-1" />
      <div class="circle circle-2" />
      <div class="circle circle-3" />
      <div class="grid-pattern" />
    </div>

    <div class="error-content">
      <!-- Boom Logo -->
      <div class="logo-container">
        <svg
          class="boom-logo"
          width="180"
          height="72"
          viewBox="0 0 200 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20 25H35C40 25 45 28 45 35C45 40 42 43 38 44C43 45 46 48 46 54C46 61 41 65 35 65H20V25Z"
            fill="#44a2a2"
          />
          <path
            d="M28 32V41H34C36 41 38 40 38 36.5C38 33 36 32 34 32H28ZM28 48V58H35C37 58 39 57 39 53C39 49 37 48 35 48H28Z"
            fill="white"
          />
          <path
            d="M55 45C55 33 63 24 75 24C87 24 95 33 95 45C95 57 87 66 75 66C63 66 55 57 55 45Z"
            fill="#44a2a2"
          />
          <path
            d="M63 45C63 53 68 59 75 59C82 59 87 53 87 45C87 37 82 31 75 31C68 31 63 37 63 45Z"
            fill="white"
          />
          <path
            d="M105 45C105 33 113 24 125 24C137 24 145 33 145 45C145 57 137 66 125 66C113 66 105 57 105 45Z"
            fill="#44a2a2"
          />
          <path
            d="M113 45C113 53 118 59 125 59C132 59 137 53 137 45C137 37 132 31 125 31C118 31 113 37 113 45Z"
            fill="white"
          />
          <path
            d="M155 25H165L175 50L185 25H195V65H187V35L177 60H173L163 35V65H155V25Z"
            fill="#44a2a2"
          />
        </svg>
      </div>

      <!-- 404 Number -->
      <div class="error-code">
        <span class="digit digit-1">4</span>
        <span class="digit digit-0">0</span>
        <span class="digit digit-2">4</span>
      </div>

      <!-- Error Message -->
      <h1 class="error-title">
        {{ $t('errors.page_not_found') }}
      </h1>
      <p class="error-description">
        {{ $t('errors.page_not_found_description') }}
      </p>

      <!-- Action Buttons -->
      <div class="action-buttons">
        <v-btn
          color="primary"
          x-large
          rounded
          elevation="2"
          class="go-home-btn"
          @click="$router.push('/dashboard')"
        >
          <v-icon left> mdi-home </v-icon>
          {{ $t('errors.go_home') }}
        </v-btn>
        <v-btn
          outlined
          color="primary"
          x-large
          rounded
          class="go-back-btn ml-4"
          @click="goBack"
        >
          <v-icon left> mdi-arrow-left </v-icon>
          {{ $t('errors.go_back') }}
        </v-btn>
      </div>

      <!-- Help Text -->
      <p class="help-text">
        {{ $t('errors.need_help') }}
        <a href="mailto:support@boomnow.com" class="support-link">
          {{ $t('errors.contact_support') }}
        </a>
      </p>
    </div>
  </div>
</template>

<script>
/**
 * Error page component displayed when no route matches
 * Features Boom branding and modern animated design
 */
export default {
  name: 'ErrorPage',
  methods: {
    /**
     * Navigate back to previous page or dashboard if no history
     */
    goBack() {
      if (window.history.length > 2) {
        this.$router.go(-1)
      } else {
        this.$router.push('/dashboard')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.error-page {
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #f8fafb 0%, #e8f4f4 50%, #f0f7f7 100%);
}

// Animated background elements
.bg-elements {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
}

.circle {
  position: absolute;
  border-radius: 50%;
  opacity: 0.15;
}

.circle-1 {
  width: 600px;
  height: 600px;
  background: linear-gradient(180deg, #44a2a2 0%, transparent 100%);
  top: -200px;
  right: -100px;
  animation: float 20s ease-in-out infinite;
}

.circle-2 {
  width: 400px;
  height: 400px;
  background: linear-gradient(180deg, #fa825b 0%, transparent 100%);
  bottom: -100px;
  left: -100px;
  animation: float 15s ease-in-out infinite reverse;
}

.circle-3 {
  width: 300px;
  height: 300px;
  background: linear-gradient(180deg, #464673 0%, transparent 100%);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: pulse 10s ease-in-out infinite;
}

.grid-pattern {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: linear-gradient(
      rgba(68, 162, 162, 0.03) 1px,
      transparent 1px
    ),
    linear-gradient(90deg, rgba(68, 162, 162, 0.03) 1px, transparent 1px);
  background-size: 60px 60px;
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-30px) rotate(5deg);
  }
}

@keyframes pulse {
  0%,
  100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.1;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.1);
    opacity: 0.15;
  }
}

// Content container
.error-content {
  position: relative;
  z-index: 1;
  text-align: center;
  padding: 40px;
  max-width: 600px;
}

// Logo
.logo-container {
  margin-bottom: 32px;
  animation: fadeInDown 0.8s ease-out;
}

.boom-logo {
  filter: drop-shadow(0 4px 12px rgba(68, 162, 162, 0.2));
}

// 404 Number
.error-code {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-bottom: 24px;
}

.digit {
  font-family: 'Montserrat', sans-serif;
  font-size: 120px;
  font-weight: 800;
  line-height: 1;
  background: linear-gradient(135deg, #44a2a2 0%, #2d7a7a 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: none;
}

.digit-1 {
  animation: bounceIn 0.6s ease-out 0.2s both;
}

.digit-0 {
  animation: bounceIn 0.6s ease-out 0.4s both;
  color: #fa825b;
  background: linear-gradient(135deg, #fa825b 0%, #e05a3a 100%);
  -webkit-background-clip: text;
  background-clip: text;
}

.digit-2 {
  animation: bounceIn 0.6s ease-out 0.6s both;
}

@keyframes bounceIn {
  0% {
    opacity: 0;
    transform: scale(0.3) translateY(-20px);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// Text styles
.error-title {
  font-family: 'Montserrat', sans-serif;
  font-size: 28px;
  font-weight: 700;
  color: #464673;
  margin-bottom: 12px;
  animation: fadeInUp 0.6s ease-out 0.8s both;
}

.error-description {
  font-family: 'Montserrat', sans-serif;
  font-size: 16px;
  color: #8f90a6;
  margin-bottom: 40px;
  line-height: 1.6;
  animation: fadeInUp 0.6s ease-out 1s both;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// Buttons
.action-buttons {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 32px;
  animation: fadeInUp 0.6s ease-out 1.2s both;
}

.go-home-btn {
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: none;
  padding: 0 32px !important;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(68, 162, 162, 0.3) !important;
  }
}

.go-back-btn {
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: none;
  padding: 0 32px !important;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    background-color: rgba(68, 162, 162, 0.08);
  }
}

// Help text
.help-text {
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  color: #8f90a6;
  animation: fadeInUp 0.6s ease-out 1.4s both;
}

.support-link {
  color: #44a2a2;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.2s ease;

  &:hover {
    color: #2d7a7a;
    text-decoration: underline;
  }
}

// Responsive adjustments
@media (max-width: 600px) {
  .error-content {
    padding: 24px;
  }

  .digit {
    font-size: 80px;
  }

  .error-title {
    font-size: 22px;
  }

  .error-description {
    font-size: 14px;
  }

  .action-buttons {
    flex-direction: column;
    align-items: center;
  }

  .go-back-btn {
    margin-left: 0 !important;
  }
}
</style>
